// import React,{Component} from "react";
// import { createBrowserHistory } from "history";
// import { Router, Route, Switch, Redirect, browserHistory } from "react-router-dom";
// import Sub from "layouts/Sub.jsx";
// import AuthLayout from "layouts/Auth.jsx";
// import AdminLayout from "layouts/Admin.jsx";
// import cookie from 'react-cookies';
// import "bootstrap/dist/css/bootstrap.css";
// import "assets/scss/paper-dashboard.scss?v=1.1.0";
// import "assets/demo/demo.css";
// import "perfect-scrollbar/css/perfect-scrollbar.css";
// import { Provider } from 'react-redux'
// import { createStore } from 'redux';
// import reducer from '../src/reducer/index';
// import { connect } from 'react-redux';
// import Loader from 'react-loader';
// import { setAlert, intStatus } from 'action/index.js';
// import NotificationAlert from "react-notification-alert";
// import {store,persistor} from 'store/index';
// import Home from './page/Home';
// import Home1 from './page/pteportal/Home';
// import ContactPortal from './page/pteportal/Contact';
// import AboutPortal from './page/pteportal/About';
// import LoginPortal from './page/pteportal/auth/Login';
// import SignupPortal from './page/pteportal/auth/Register';
// import ForgotPortal from './page/pteportal/auth/Forgot';
// import VideoCourse from './page/VideoCourse';
// import VideoCourseR3 from './page/VideoCourseR3';
// import WhatWeOffer from './page/WhatWeOffer';
// import MockPlan from './page/MockPlan';
// import Contact from './page/Contact';
// import About from './page/About';
// import PayOnline from './page/PayOnline';
// import JoinUs from './page/JoinUs';
// import Branches from './page/Branches';
// import Franchise from './page/Franchise';
// import NaatiAppLp from './page/NaatiAppLp';
// import FreeMockTest from './page/FreeMockTest';
// import Naati from './page/Naati';
// import Pte from './page/Pte';
// import ReadingPte from './page/ReadingPte';
// import WritingPte from './page/WritingPte';
// import SpeakingPte from './page/SpeakingPte';
// import ListeningPte from './page/ListeningPte';
// import PteOnlineClasses from './page/PteOnlineClasses';
// import PteMockTest from './page/PteMockTest';
// import PteStudyMaterial from './page/PteStudyMaterial';
// import Term from './page/Term';
// import Feedback from './page/Feedback';
// import DailyFeedback from './page/DailyFeedback';
// import Refund from './page/Refund';
// import VideoAll from './page/VideoAll';
// import TestimonialAll from './page/TestimonialAll';
// import ScoreCardAll from './page/ScoreCardAll';
// import PteOnlineCoaching from './page/PteOnlineCoaching';
// import NaatiOnlineCoaching from './page/NaatiOnlineCoaching';
// import PteCoachingSydney from './page/PteCoachingSydney';
// import IeltsOnlineCoaching from './page/IeltsOnlineCoaching';
// import IeltsCoachingParramatta from './page/IeltsCoachingParramatta';
// import IeltsCoachingSydney from './page/IeltsCoachingSydney';
// import NaatiCoachingSydney from './page/NaatiCoachingSydney';
// import Sitemap from './page/Sitemap';
// import NotFound from './page/NotFound';
// import ThankYou from './page/ThankYou';
// import ThankYouPayout from './page/ThankYouPayout';
// import ThankYouRegister from './page/ThankYouRegister';
// import robot from './components/robots.txt';
// import Sitemap1 from './components/sitemap.xml';
// import fb from './components/googleaa7a8b2d6a176fd2.txt';
// import Maintenance from "./page/Maintenance";
// import { isMobile } from 'react-device-detect';
// import DownloadApp from "components/PopUps/DownloadApp";
// import MobileDetect from "mobile-detect";
// import { SnackbarProvider, enqueueSnackbar, closeSnackbar } from 'notistack';
// import PteCore from './page/PteCore';
// import NepalBranch from "components/PopUps/NepalBranch";
// import ChromePopUp from "components/PopUps/Chrome";
// import LaLoader from "components/Loader/LaLoader.jsx";
// import LeadThanks from "components/ThankYou/ThankYou";
// import { setLoader } from "action";
// import PrivacyPolicy from "page/PrivacyPolicy";
// import Inst from "page/Inst";
// import BusinessPage from "page/BusinessPage";
// import RedirectToHome from './page/RedirectToHome';
// import { ToastContainer } from "react-toastify";
// import Subscription from "page/Payment";
// import MagicTokenLogin from "page/MagicTokenLogin";
// import SubSuccess from "page/SubSuccess";
// import SalesPage from "page/SalesPage";
// // import RedirectTo from "page/RedirectTo";
// import ScrollToTop from "./hooks/scrollToTop.js";
// import InvalidRegion from "./page/InvalidRegion";

// const hist = createBrowserHistory();

// const mapStateToProps = (state) => {
//    return {
//       token: state.token,
//       loaded: state.loaded,
//       user: state.user,
//       subscribed:state.subscribed,
//       alert:state.alert
//    };
// };

// class ReactRouteAll extends Component{
// 	// constructor(props) {
// 	// 	super(props);
// 	// 	this.state = {
// 	// 	  isMounted: false,
// 	// 	  os: ""
// 	// 	};
// 	//   }
// constructor(props) {
//   super(props);
//   this.notificationAlertRef = React.createRef();
// }
// 	isPortalUrl = (pathname) => {
// 		const starts_with = pathname.indexOf('/admin/');
// 		if (starts_with === 0) {
// 			document.querySelector("html").classList.add('student-portal');
// 		} else {
// 			document.querySelector("html").classList.remove('student-portal');
// 		}
// 	}

// 	isDashboard = (pathname) => {
// 		const starts_with = pathname.indexOf('/admin/dashboard');
// 		if (starts_with === 0) {
// 			document.querySelector("html").classList.add('student-dashboard');
// 		} else {
// 			document.querySelector("html").classList.remove('student-dashboard');
// 		}
// 	}

// 	componentDidMount() {
// 		store.dispatch(setLoader(true));
// 		store.dispatch(intStatus(true));
// 		if (this.props.loaded) {
// 			window.addEventListener("load", () => {
// 				let snackbarId;
// 				// 1st, we set the correct status when the page loads
// 				// navigator.onLine
// 				// 	? closeSnackbar(snackbarId)
// 				// 	: snackbarId =  enqueueSnackbar("No internet connection", {
// 				// 		variant: "error",
// 				// 		persist: true,
// 				// 	});

// 				// now we listen for network status changes
// 				window.addEventListener("online", () => {
// 					closeSnackbar(snackbarId);
// 					store.dispatch(intStatus(true));
// 					document.getElementById("internet-down").remove();
// 				});

// 				window.addEventListener("offline", () => {
// 					snackbarId = enqueueSnackbar("No internet connection", {
// 						variant: "error",
// 						persist: true,
// 					});
// 					store.dispatch(intStatus(false));
// 					// if (window.location.pathname.includes('/admin/test') || window.location.pathname.includes('/admin/practice')) {
// 						const div = document.createElement("div");
// 						div.className = "modal-backdrop fade show";
// 						div.id = "internet-down";
// 						if(document.getElementsByClassName('wrapper').length > 0) {
// 							document.getElementsByClassName('wrapper')[0].appendChild(div);
// 						} else if(document.getElementsByClassName('dashboardPage').length > 0) {
// 							document.getElementsByClassName('dashboardPage')[0].appendChild(div);
// 						} else {
// 							document.getElementById('root').appendChild(div);
// 						}
// 					// }
// 				});
// 			});
// 		}

// 		// check pathname on page load.
// 		setTimeout(() => {
// 			this.isPortalUrl(hist.location.pathname);
// 			this.isDashboard(hist.location.pathname);
// 		}, 500);

// 		// listen to navigation (path change.)
// 		this.unlisten = hist.listen( location =>  {
// 			this.isPortalUrl(location.pathname);
// 			this.isDashboard(location.pathname);
// 		});
// 	}
// 	componentWillUnmount() {
// 		this.unlisten();
// 	}
// 	notify = (type,message) => {

// 	    switch (type) {
// 	      case 1:
// 	        type = "success";
// 	        break;
// 	      case 2:
// 	        type = "danger";
// 	        break;
// 	      default:
// 	        break;
// 	    }
// 	    var options = {};
// 	    options = {
// 	      place: 'tr',
// 	      message: (
// 	        <div>
// 	          <div>
// 	            {message}
// 	          </div>
// 	        </div>
// 	      ),
// 	      type: type,
// 	      icon: "now-ui-icons ui-1_bell-53",
// 	      autoDismiss: 7
// 	    };
// if (this.notificationAlertRef.current) {
//   this.notificationAlertRef.current.notificationAlert(options);
// }
// 	  };

// 	render(){
// 		const portal = [
// 			{ path:"/", component:Home1 },
// 			{ path:"/contact", component:ContactPortal },
// 			{ path:"/about", component:AboutPortal }
// 		];
// 		const portalAuth = [
// 			{ path:"/auth/login", component:LoginPortal },
// 			{ path:"/auth/register", component:SignupPortal },
// 			{ path:"/auth/forgot", component:ForgotPortal }
// 		];
// 		const subAuth = [
// 			{ path:"/auth/login", component:LoginPortal }
// 		];

// 		/** FMT and VC. */
// 		let videoCourseComponent;
// 		let freeMockTestComponent;
// 		if (import.meta.env.VITE_SHOW_PAGES === "0") {
// 			videoCourseComponent = RedirectToHome;
// 			freeMockTestComponent = RedirectToHome;
// 		} else {
// 			// videoCourseComponent = VideoCourse;
// 			videoCourseComponent = RedirectToHome; // this is temp. redirection.
// 			freeMockTestComponent = RedirectToHome; // this will redirect to mock-test page.
// 		}
// 		/** ---------- */

// 		const front = [
// 			{ path:"/", component:Home },
// 			{ path:"/robots.txt", component:robot },
// 			{ path:"/googleaa7a8b2d6a176fd2.html", componen:fb },

// 			{ path:"/video-courses", component:VideoCourse },
// 			{ path:"/video-courses-r3", component:VideoCourseR3 },
// 			// { path:"/video-courses", component: videoCourseComponent },

// 			{ path:"/ai-in-education", component:WhatWeOffer },
// 			{ path:"/about", component:About },
// 			{ path:"/maintenance", component:Maintenance },
// 			{ path:"/pay-online", component:PayOnline },
// 			{ path:"/join-us", component:JoinUs },
// 			{ path:"/branches", component:Branches },
// 			{ path:"/franchise", component:Franchise },
// 			{ path:"/naati-app-lp", component:NaatiAppLp },

// 			{ path:"/mock-test", component:FreeMockTest },
// 			{ path:"/free-mock-test", component: freeMockTestComponent },

// 			{ path:"/mock-feedback/:id", component:Feedback },
// 			{ path:"/daily-feedback", component:DailyFeedback },
// 			{ path:"/contact", component:Contact },
// 			{ path:"/pte-coaching-classes-parramatta", component:Pte },
// 			{ path:"/naati-coaching-classes-parramatta", component:Naati },
// 			{ path:"/pte-reading-test-practice-material", component:ReadingPte },
//    		{ path:"/pte-speaking-test-practice-material", component:SpeakingPte },
//    		{ path:"/pte-writing-test-practice-material", component:WritingPte },
//    		{ path:"/pte-listening-test-practice-material", component:ListeningPte},
//    		{ path:"/pte-online-classes", component:PteOnlineClasses },
// 		   { path:"/pte-mock-test", component:PteMockTest },
//    		{ path:"/pte-study-material", component:PteStudyMaterial },
//    		{ path:"/term", component:Term },
//    		{ path:"/privacy-policy", component:PrivacyPolicy },
// 		   { path:"/video-all", component:VideoAll },
//    		{ path:"/testimonial-all", component:TestimonialAll },
//    		{ path:"/refund-policies", component:Refund },
//    		{ path:"/scorecard", component:ScoreCardAll },
//    		{ path:"/sitemap", component:Sitemap },
//    		{ path:"/sitemap.xml", component:Sitemap1 },
//    		{ path:"/pte-online-coaching", component:PteOnlineCoaching },
//    		{ path:"/naati-ccl-online-coaching", component:NaatiOnlineCoaching },
//    		{ path:"/pte-coaching-sydney", component:PteCoachingSydney },
//    		{ path:"/ielts-online-coaching", component:IeltsOnlineCoaching },
// 		   { path:"/ielts-coaching-parramatta", component:IeltsCoachingParramatta },
//    		{ path:"/ielts-coaching-sydney", component:IeltsCoachingSydney },
//    		{ path:"/naati-ccl-coaching-sydney", component:NaatiCoachingSydney },
//    		{ path:"/thank-you", component:ThankYou },
// 			{ path:"/trial-class-thankyou", component:LeadThanks },
// 			{ path:"/thank-you-payout", component:ThankYouPayout },
// 			{ path:"/register-success", component:ThankYouRegister },
// 			{ path:"/pte-core", component:PteCore },
// 			// { path: "/institutes", component: Institute },
// 			{ path: "/inst", component: Inst },
// 			{ path: "/business", component: BusinessPage },
// 			{ path: "/user-login", component: MagicTokenLogin},
// 			{ path: "/pay-success", component: SubSuccess},
// 			{ path: "/sales", component: SalesPage},
// 			{ path: "/invalid/region", component: InvalidRegion }

//    		// { path:"/pte-speaking", component: RedirectTo },
//    		// { path:"/pte-writing", component: RedirectTo },
// 		// 	{ path:"/pte-reading", component: RedirectTo },
//    		// { path:"/pte-listening", component: RedirectTo },
// 		];
// 		const isMainSite = (window.location.hostname.split('.').shift() === "www")?true:false;
// 		if (this.props.alert.flag) {
// 			this.notify(this.props.alert.type,this.props.alert.message);
// 			store.dispatch(setAlert({'flag':false}));
// 		}
// 		return(
// 			<React.Fragment>
// 				{/* {isMobile && <DownloadApp os="test"/>} */}
// 				<LaLoader show={!this.props.loaded} />
// 				<SnackbarProvider maxSnack={2} />
// 				<NepalBranch />
// 				{/* <ChromePopUp /> */}
// <NotificationAlert ref={this.notificationAlertRef} />
// 				{!store.getState().is_portal && store.getState().is_main &&
// 					<Router history={hist}>
// 						<ScrollToTop>
// 							<Switch>
// 								{ front.length > 0 && front.map(props => <Route key={props.path} {...props} exact />)}
// 								{ <Route path="/auth" render={props => <AuthLayout {...props} />} /> }
// 								{ (this.props.token != null) && <Route path="/admin" render={props => <AdminLayout {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/subscription" render={props => <Sub {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/admin/sub/payment/form" render={props => <AdminLayout {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/admin/sub/success" render={props => <AdminLayout {...props} />} />}
// 								{ false && (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ (this.props.token === null) && <Redirect to="/auth/login/session-expired" />}
// 								{ (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ false && (this.props.token != null) && !this.props.subscribed && <Redirect to="/sub/subscription" />}
// 								<Route component={NotFound} exact />
// 							</Switch>
// 							{/* <ChromePopUp /> */}
// 							{isMobile && <DownloadApp os="test"/>}
// 						</ScrollToTop>
// 					</Router>
// 				}
// 				{store.getState().is_portal && store.getState().is_main &&
// 					<Router history={hist}>
// 						<ScrollToTop>
// 							<Switch>
// 								{portal.length >0 && portal.map(props => <Route {...props} exact />)}
// 								{portalAuth.length >0 && portalAuth.map(props => <Route {...props} exact />)}
// 								{ (this.props.token != null)  && <Route path="/admin" render={props => <AdminLayout {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/subscription" render={props => <Sub {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/payment/form" render={props => <Sub {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/success" render={props => <Sub {...props} />} />}
// 								{ false && (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ (this.props.token === null) && <Redirect to="/auth/login" />}
// 								{ (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ false && (this.props.token != null) && !this.props.subscribed && <Redirect to="/sub/subscription" />}
// 								<Route component={NotFound} exact />
// 							</Switch>
// 							{/* <ChromePopUp /> */}
// 							{isMobile && <DownloadApp os="test"/>}
// 						</ScrollToTop>
// 					</Router>
// 				}
// 				{!store.getState().is_main &&
// 					<Router history={hist}>
// 						<ScrollToTop>
// 							<Switch>
// 								{subAuth.length > 0 && subAuth.map(props => <Route {...props} exact />)}
// 								{ (this.props.token != null)  && <Route path="/admin" render={props => <AdminLayout {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/subscription" render={props => <Sub {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/payment/form" render={props => <Sub {...props} />} />}
// 								{ (this.props.token != null) && <Route path="/sub/success" render={props => <Sub {...props} />} />}
// 								{ false && (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ (this.props.token === null) && <Redirect to="/auth/login" />}
// 								{ (this.props.token != null) && <Redirect to="/admin/dashboard" />}
// 								{ false && (this.props.token != null) && !this.props.subscribed && <Redirect to="/sub/subscription" />}
// 								<Route component={NotFound} exact />
// 							</Switch>
// 							{/* <ChromePopUp /> */}
// 							{isMobile && <DownloadApp os="test"/>}
// 						</ScrollToTop>
// 					</Router>
// 				}
// 				<ToastContainer
// 					position="top-right"
// 					autoClose={false}
// 					newestOnTop={false}
// 					closeOnClick={false}
// 					rtl={false}
// 					pauseOnFocusLoss
// 					draggable
// 					theme="light"
// 				/>
// 			</React.Fragment>
// 		);
// 	}
// }

// export default connect(mapStateToProps,null)(ReactRouteAll);
import React, { useEffect, useRef } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Sub from "layouts/Sub.jsx";
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import cookie from "react-cookies";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
import "assets/demo/demo.css";
// import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Provider, useSelector } from "react-redux";
import { createStore } from "redux";
import reducer from "../src/reducer/index";
import { connect } from "react-redux";
import Loader from "react-loader";
import { setAlert, intStatus } from "action/index.js";
// import NotificationAlert from "react-notification-alert";
import { store, persistor } from "store/index";
import Home from "./page/Home";
import Home1 from "./page/pteportal/Home";
import ContactPortal from "./page/pteportal/Contact";
import AboutPortal from "./page/pteportal/About";
import LoginPortal from "./page/pteportal/auth/Login";
import SignupPortal from "./page/pteportal/auth/Register";
import ForgotPortal from "./page/pteportal/auth/Forgot";
import VideoCourse from "./page/VideoCourse";
import VideoCourseR3 from "./page/VideoCourseR3";
import WhatWeOffer from "./page/WhatWeOffer";
import MockPlan from "./page/MockPlan";
import Contact from "./page/Contact";
import About from "./page/About";
import PayOnline from "./page/PayOnline";
import JoinUs from "./page/JoinUs";
import Branches from "./page/Branches";
import Franchise from "./page/Franchise";
// import NaatiAppLp from "./page/NaatiAppLp";
import NaatiAppNew from "./page/NaatiAppNew";
import PTEAppNew from "./page/PTEAppNew";
import FreeMockTest from "./page/FreeMockTest";
import Naati from "./page/Naati";
import Pte from "./page/Pte";
import ReadingPte from "./page/ReadingPte";
import WritingPte from "./page/WritingPte";
import SpeakingPte from "./page/SpeakingPte";
import ListeningPte from "./page/ListeningPte";
import PteOnlineClasses from "./page/PteOnlineClasses";
import PteMockTest from "./page/PteMockTest";
import PteStudyMaterial from "./page/PteStudyMaterial";
import Term from "./page/Term";
import Feedback from "./page/Feedback";
import DailyFeedback from "./page/DailyFeedback";
import Refund from "./page/Refund";
import VideoAll from "./page/VideoAll";
import TestimonialAll from "./page/TestimonialAll";
import ScoreCardAll from "./page/ScoreCardAll";
import PteOnlineCoaching from "./page/PteOnlineCoaching";
import NaatiOnlineCoaching from "./page/NaatiOnlineCoaching";
import PteCoachingSydney from "./page/PteCoachingSydney";
import IeltsOnlineCoaching from "./page/IeltsOnlineCoaching";
import IeltsCoachingParramatta from "./page/IeltsCoachingParramatta";
import IeltsCoachingSydney from "./page/IeltsCoachingSydney";
import NaatiCoachingSydney from "./page/NaatiCoachingSydney";
import Sitemap from "./page/Sitemap";
import NotFound from "./page/NotFound";
import ThankYou from "./page/ThankYou";
import ThankYouPayout from "./page/ThankYouPayout";
import ThankYouRegister from "./page/ThankYouRegister";
import robot from "./components/robots.txt";
// import Sitemap1 from "./components/sitemap.xml";
import fb from "./components/googleaa7a8b2d6a176fd2.txt";
import Maintenance from "./page/Maintenance";
import { isMobile } from "react-device-detect";
import DownloadApp from "components/PopUps/DownloadApp";
import MobileDetect from "mobile-detect";
import { SnackbarProvider, enqueueSnackbar, closeSnackbar } from "notistack";
import PteCore from "./page/PteCore";
import NepalBranch from "components/PopUps/NepalBranch";
import ChromePopUp from "components/PopUps/Chrome";
import LaLoader from "components/Loader/LaLoader.jsx";
import LeadThanks from "components/ThankYou/ThankYou";
import { setLoader } from "action";
import PrivacyPolicy from "page/PrivacyPolicy";
import Inst from "page/Inst";
import BusinessPage from "page/BusinessPage";
import RedirectToHome from "./page/RedirectToHome";
import { toast } from "react-toastify";
import Subscription from "page/Payment";
import MagicTokenLogin from "page/MagicTokenLogin";
import SubSuccess from "page/SubSuccess";
import SalesPage from "page/SalesPage";
import ScrollToTop from "./hooks/scrollToTop.js";
import InvalidRegion from "./page/InvalidRegion";
import Login from "views/pages/Login";
import routes from "routes";
import Dashboard from "views/DashboardNew";
import LoginWithCaptcha from "views/pages/LoginWithCaptcha";
import SuccessCard from "components/Payments/SuccessCard";
import InvalidRegionAccess from "page/InvalidRegionAccess";
import MobileAppBanner from "components/Dashboard/New/MobileAppBanner";
import useFirebaseNotification from "./hooks/useFirebaseNotification";
import YouTubeModal from "components/Notification/YoutubeModal";
import { initGA, trackPageView ,initMetaPixel , initTikTok ,trackMetaPageView,trackTikTokPageView } from "util/analytics";

const hist = createBrowserHistory();

const mapStateToProps = (state) => {
  return {
    token: state.token,
    loaded: state.loaded,
    user: state.user,
    subscribed: state.subscribed,
    alert: state.alert,
  };
};

import { cleanupAllTours } from "components/WebsiteTour/tourData";

const ReactRouteAll = ({ token, loaded, user, subscribed, alert }) => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);
  const snackbarRef = useRef(null);
  const intStatuscheck = useSelector((state) => state.intStatus);
  const { fcmToken, notification, youtubeModal, setYoutubeModal } = useFirebaseNotification();
  console.log("The intstatuscheck : ",intStatuscheck);
  // Cleanup tours and handle GTM persistence on route change

  useEffect(() => {
  initGA();
  initMetaPixel('197333187452630');
  initTikTok('CG0870RC77U8JD8FUT4G');
  console.log('Analytics initialized');
}, []);

  useEffect(() => {

    if (prevLocation.current !== location.pathname) {
      cleanupAllTours();
      prevLocation.current = location.pathname;
    }
      trackPageView(location.pathname + location.search);
       trackMetaPageView();
    trackTikTokPageView();
    
  }, [location.pathname , location.search]);

  useEffect(() => {
    if (fcmToken) {
      console.log('FCM Token:', fcmToken);
    }
  }, [fcmToken]);

  useEffect(() => {
    if (notification) {
      console.log('New notification:', notification);
    }
  }, [notification]);

  // const notificationAlertRef = useRef(null);
  const isPortalUrl = (pathname) => {
    if (!pathname || typeof pathname !== "string") return; // safeguard
    const starts_with = pathname.indexOf("/admin/");
    if (starts_with === 0) {
      document.querySelector("html").classList.add("student-portal");
    } else {
      document.querySelector("html").classList.remove("student-portal");
    }
  };

  const isDashboard = (pathname) => {
    if (!pathname || typeof pathname !== "string") return;
    const starts_with = pathname.indexOf("/admin/dashboard");
    if (starts_with === 0) {
      document.querySelector("html").classList.add("student-dashboard");
    } else {
      document.querySelector("html").classList.remove("student-dashboard");
    }
  };

  // const notify = (type, message) => {
  //   switch (type) {
  //     case 1:
  //       type = "success";
  //       break;
  //     case 2:
  //       type = "danger";
  //       break;
  //     default:
  //       break;
  //   }
  //   const options = {
  //     place: "tr",
  //     message: (
  //       <div>
  //         <div>{message}</div>
  //       </div>
  //     ),
  //     type: type,
  //     icon: "now-ui-icons ui-1_bell-53",
  //     autoDismiss: 7,
  //   };
  //   // if (notificationAlertRef.current) {
  //   //   notificationAlertRef.current.notificationAlert(options);
  //   // }
  // };

  const notify = (type, message) => {
    const options = {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };

    switch (type) {
      case 1:
        toast.success(message, options);
        break;
      case 2:
        toast.error(message, options);
        break;
      default:
        toast.info(message, options);
        break;
    }
  };

  // useEffect(() => {
  //   store.dispatch(setLoader(true));
  //   store.dispatch(intStatus(true));
  //   if (loaded) {
  //     window.addEventListener("load", () => {
  //       let snackbarId;
  //       window.addEventListener("online", () => {
  //         closeSnackbar(snackbarId);
  //         store.dispatch(intStatus(true));
  //         document.getElementById("internet-down").remove();
  //       });

  //       window.addEventListener("offline", () => {
  //         snackbarId = enqueueSnackbar("No internet connection", {
  //           variant: "error",
  //           persist: true,
  //         });
  //         store.dispatch(intStatus(false));
  //         const div = document.createElement("div");
  //         div.className = "modal-backdrop fade show";
  //         div.id = "internet-down";
  //         if (document.getElementsByClassName("wrapper").length > 0) {
  //           document.getElementsByClassName("wrapper")[0].appendChild(div);
  //         } else if (
  //           document.getElementsByClassName("dashboardPage").length > 0
  //         ) {
  //           document
  //             .getElementsByClassName("dashboardPage")[0]
  //             .appendChild(div);
  //         } else {
  //           document.getElementById("root").appendChild(div);
  //         }
  //       });
  //     });
  //   }

  //   setTimeout(() => {
  //     isPortalUrl(hist.location.pathname);
  //     isDashboard(hist.location.pathname);
  //   }, 500);

  //   const unlisten = hist.listen((location) => {
  //     isPortalUrl(location.pathname);
  //     isDashboard(location.pathname);
  //   });

  //   return () => {
  //     unlisten();
  //   };
  // }, [loaded]);

 useEffect(() => {
  if (!loaded) return;

  store.dispatch(setLoader(true));
  store.dispatch(intStatus(navigator.onLine));

  const handleOnline = () => {
    if (snackbarRef.current) {
      closeSnackbar(snackbarRef.current);
      snackbarRef.current = null;
    }

    store.dispatch(intStatus(true));

    const el = document.getElementById("internet-down");
    if (el) el.remove();
  };

 const handleOffline = () => {
  if (snackbarRef.current) return;

  snackbarRef.current = "pending"; // <-- block duplicates immediately

  snackbarRef.current = enqueueSnackbar("No internet connection", {
    variant: "error",
    persist: true,
  });

  store.dispatch(intStatus(false));

  if (!document.getElementById("internet-down")) {
    const div = document.createElement("div");
    div.className = "modal-backdrop fade show";
    div.id = "internet-down";

    const parent =
      document.querySelector(".wrapper") ||
      document.querySelector(".dashboardPage") ||
      document.getElementById("root");

    parent.appendChild(div);
  }
};

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
}, [loaded]);

  useEffect(() => {
    if (location?.pathname) {
      isPortalUrl(location.pathname);
      isDashboard(location.pathname);
    }
  }, [location?.pathname]);

  useEffect(() => {
    if (alert.flag) {
      notify(alert.type, alert.message);
      store.dispatch(setAlert({ flag: false }));
    }
  }, [alert]);

  useEffect(() => {}, [token]);

  const portal = [
    { path: "/", component: Home1 },
    { path: "/contact", component: ContactPortal },
    { path: "/about", component: AboutPortal },
  ];
  const portalAuth = [
    { path: "/auth/login", component: LoginPortal },
    { path: "/auth/register", component: SignupPortal },
    { path: "/auth/forgot", component: ForgotPortal },
  ];
  const subAuth = [{ path: "/auth/login", component: LoginPortal }];

  let videoCourseComponent;
  let freeMockTestComponent;
  if (import.meta.env.VITE_SHOW_PAGES === "0") {
    videoCourseComponent = RedirectToHome;
    freeMockTestComponent = RedirectToHome;
  } else {
    videoCourseComponent = RedirectToHome; // this is temp. redirection.
    freeMockTestComponent = RedirectToHome; // this will redirect to mock-test page.
  }

  const front = [
    { path: "/", component: Home },
    { path: "/robots.txt", component: robot },
    { path: "/googleaa7a8b2d6a176fd2.html", component: fb },
    { path: "/video-courses", component: VideoCourse },
    { path: "/video-courses-r3", component: VideoCourseR3 },
    { path: "/ai-in-education", component: WhatWeOffer },
    { path: "/about", component: About },
    { path: "/maintenance", component: Maintenance },
    { path: "/pay-online", component: PayOnline },
    { path: "/join-us", component: JoinUs },
    { path: "/branches", component: Branches },
    { path: "/franchise", component: Franchise },
    // { path: "/naati-app-lp", component: NaatiAppLp },
    { path: "/naati-app", component: NaatiAppNew },
    { path: "/pte-app", component: PTEAppNew },
    { path: "/mock-test", component: FreeMockTest },
    { path: "/free-mock-test", component: freeMockTestComponent },
    { path: "/mock-feedback/:id", component: Feedback },
    { path: "/daily-feedback", component: DailyFeedback },
    { path: "/contact", component: Contact },
    { path: "/pte-coaching-classes-parramatta", component: Pte },
    { path: "/naati-coaching-classes-parramatta", component: Naati },
    { path: "/pte-reading-test-practice-material", component: ReadingPte },
    { path: "/pte-speaking-test-practice-material", component: SpeakingPte },
    { path: "/pte-writing-test-practice-material", component: WritingPte },
    { path: "/pte-listening-test-practice-material", component: ListeningPte },
    { path: "/pte-online-classes", component: PteOnlineClasses },
    { path: "/pte-mock-test", component: PteMockTest },
    { path: "/pte-study-material", component: PteStudyMaterial },
    { path: "/term", component: Term },
    { path: "/privacy-policy", component: PrivacyPolicy },
    { path: "/video-all", component: VideoAll },
    { path: "/testimonial-all", component: TestimonialAll },
    { path: "/refund-policies", component: Refund },
    { path: "/scorecard", component: ScoreCardAll },
    { path: "/sitemap", component: Sitemap },
    // { path: "/sitemap.xml", component: Sitemap1 },
    { path: "/pte-online-coaching", component: PteOnlineCoaching },
    { path: "/naati-ccl-online-coaching", component: NaatiOnlineCoaching },
    { path: "/pte-coaching-sydney", component: PteCoachingSydney },
    { path: "/ielts-online-coaching", component: IeltsOnlineCoaching },
    { path: "/ielts-coaching-parramatta", component: IeltsCoachingParramatta },
    { path: "/ielts-coaching-sydney", component: IeltsCoachingSydney },
    { path: "/naati-ccl-coaching-sydney", component: NaatiCoachingSydney },
    { path: "/thank-you", component: ThankYou },
    { path: "/trial-class-thankyou", component: LeadThanks },
    { path: "/thank-you-payout", component: ThankYouPayout },
    { path: "/register-success", component: ThankYouRegister },
    { path: "/pte-core", component: PteCore },
    { path: "/inst", component: Inst },
    { path: "/business", component: BusinessPage },
    { path: "/user-login", component: MagicTokenLogin },
    { path: "/pay-success", component: SuccessCard },
    { path: "/sales", component: SalesPage },
    // { path: "/invalid/region", component: InvalidRegion },
    { path: "/invalid/region", component: InvalidRegionAccess }
  ];

  const isMainSite = window.location.hostname.split(".").shift() === "www";

  const getAdminRoutes = (routeList = routes) => {
    const result = [];

    routeList.forEach((route) => {
      if (route.collapse && route.views) {
        result.push(...getAdminRoutes(route.views));
      } else if (route.layout === "/admin" && route.path) {
        const childPath = route.path.startsWith("/")
          ? route.path.slice(1)
          : route.path;

        const Component = route.component;

        result.push(
          <Route key={childPath} path={childPath} element={<Component />} />
        );
      }
    });

    return result;
  };

  const getAuthRoutes = (routeList = routes) => {
    const result = [];

    routeList.forEach((route) => {
      if (route.collapse && route.views) {
        // recursively check nested routes
        result.push(...getAuthRoutes(route.views));
      } else if (route.layout === "/auth" && route.path) {
        const childPath = route.path.startsWith("/")
          ? route.path.slice(1)
          : route.path;

        const Component = route.component;

        result.push(
          <Route key={childPath} path={childPath} element={<Component />} />
        );
      }
    });

    return result;
  };

  const bannerExcludedPaths = [
    "/admin/mock",
    "/admin/extensive/new-sectional-tests",
    "/admin/fulltest",
    "/admin/sectionalTest",
    "/admin/test"
  ];

  return (
    <React.Fragment>
      <YouTubeModal
        isOpen={youtubeModal.isOpen}
        toggle={() => setYoutubeModal({ isOpen: false, url: '', title: '' })}
        videoUrl={youtubeModal.url}
        title={youtubeModal.title}
      />
      {!bannerExcludedPaths.some(path => location.pathname.includes(path)) && <MobileAppBanner />}
      {isMobile && <DownloadApp os="test" />}
      {/* <LaLoader show={loaded} /> */}
      <SnackbarProvider maxSnack={2} />
      <NepalBranch />
      {/* <NotificationAlert ref={notificationAlertRef} /> */}
      {/* {!store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Routes>
            {front.length > 0 &&
              front.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={<props.component />}
                  exact
                />
              ))}
            <Route path="/auth/*" element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              {getAuthRoutes()}
            </Route>

            {token != null && (
              <Route path="/admin/*" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                {getAdminRoutes()}
              </Route>
            )}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/admin/sub/payment/form" element={<AdminLayout />} />
            )}
            {token != null && (
              <Route path="/admin/sub/success" element={<AdminLayout />} />
            )}
            {token === null && (
              <Route
                path="/auth/login/session-expired"
                element={<Navigate to="/auth/login/session-expired" replace />}
              />
            )}
            <Route path="*" element={<NotFound />} exact />
          </Routes>
          <ChromePopUp />
          {isMobile && <DownloadApp os="test" />}
        </ScrollToTop>
      )} */}
      {!store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Routes>
            {front.length > 0 &&
              front.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={<props.component />}
                  exact
                />
              ))}

            {/* Auth routes */}
            <Route path="/auth/*" element={<AuthLayout />}>
              <Route path="login" element={<LoginWithCaptcha />} />
              {getAuthRoutes()}
            </Route>

            {/* Protected Admin Routes */}
            <Route
              path="/admin/*"
              element={
                token ? <AdminLayout /> : <Navigate to="/auth/login" replace />
              }
            >
              {token && (
                <>
                  <Route index element={<Navigate to="dashboard" replace />} />
                  {getAdminRoutes()}
                </>
              )}
            </Route>

            {/* Other protected routes */}
            <Route
              path="/sub/subscription"
              element={token ? <Sub /> : <Navigate to="/auth/login" replace />}
            />
            {/* <Route
              path="/admin/sub/payment/form"
              element={token ? <AdminLayout /> : <Navigate to="/auth/login" replace />}
            />
            <Route
              path="/admin/sub/success"
              element={token ? <AdminLayout /> : <Navigate to="/auth/login" replace />}
            /> */}
            {token === null && (
              <Route
                path="/auth/login/session-expired"
                element={<Navigate to="/auth/login" replace />}
              />
            )}

            <Route path="*" element={<NotFound />} exact />
          </Routes>

          <ChromePopUp />
          {isMobile && <DownloadApp os="test" />}
        </ScrollToTop>
      )}

      {store.getState().is_portal && store.getState().is_main && (
        <ScrollToTop>
          <Routes>
            {portal.length > 0 &&
              portal.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={<props.component />}
                  exact
                />
              ))}
            {portalAuth.length > 0 &&
              portalAuth.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={<props.component />}
                  exact
                />
              ))}
            {token != null && <Route path="/admin" element={<AdminLayout />} />}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/sub/payment/form" element={<Sub />} />
            )}
            {token != null && <Route path="/sub/success" element={<Sub />} />}

            {token != null && (
              <Route
                path="/admin/dashboard"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            )}
            {token === null && (
              <Route
                path="/auth/login"
                element={<Navigate to="/auth/login" replace />}
              />
            )}
            <Route path="*" element={<NotFound />} exact />
          </Routes>
          <ChromePopUp />
          {isMobile && <DownloadApp os="test" />}
        </ScrollToTop>
      )}
      {!store.getState().is_main && (
        <ScrollToTop>
          <Routes>
            {subAuth.length > 0 &&
              subAuth.map((props) => (
                <Route
                  key={props.path}
                  path={props.path}
                  element={<props.component />}
                  exact
                />
              ))}
            {token != null && <Route path="/admin" element={<AdminLayout />} />}
            {token != null && (
              <Route path="/sub/subscription" element={<Sub />} />
            )}
            {token != null && (
              <Route path="/sub/payment/form" element={<Sub />} />
            )}
            {token != null && <Route path="/sub/success" element={<Sub />} />}
            {token != null && (
              <Route
                path="/admin/dashboard"
                element={<Navigate to="/admin/dashboard" replace />}
              />
            )}
            {token === null && (
              <Route
                path="/auth/login"
                element={<Navigate to="/auth/login" replace />}
              />
            )}
            <Route path="*" element={<NotFound />} exact />
          </Routes>
          <ChromePopUp />
          {isMobile && <DownloadApp os="test" />}
        </ScrollToTop>
      )}
      
    </React.Fragment>
  );
};

export default connect(mapStateToProps, null)(ReactRouteAll);
